/**
 * Vuikit 0.8.10
 * (c) 2018 Miljan Aleksic
 * @license MIT
**/

/* Substantial part of the code is adapted from UIkit,
  Copyright (c) 2013-2018 YOOtheme GmbH, getuikit.com */

import { attr } from './attr';

var doc = typeof document !== 'undefined' && document;
var win = typeof window !== 'undefined' && window;
var nav = typeof navigator !== 'undefined' && navigator;
var isRtl = doc && attr(document.documentElement, 'dir') === 'rtl';
var hasTouchEvents = win && 'ontouchstart' in window;
var hasPointerEvents = win && window.PointerEvent;
var hasTouch = hasTouchEvents ||
  (win && window.DocumentTouch) && (doc && document instanceof window.DocumentTouch) ||
  nav && navigator.maxTouchPoints;
var pointerDown = !hasTouch ? 'mousedown' : ("mousedown " + (hasTouchEvents ? 'touchstart' : 'pointerdown'));
var pointerMove = !hasTouch ? 'mousemove' : ("mousemove " + (hasTouchEvents ? 'touchmove' : 'pointermove'));
var pointerUp = !hasTouch ? 'mouseup' : ("mouseup " + (hasTouchEvents ? 'touchend' : 'pointerup'));
var pointerEnter = hasTouch && hasPointerEvents ? 'pointerenter' : 'mouseenter';
var pointerLeave = hasTouch && hasPointerEvents ? 'pointerleave' : 'mouseleave';

export { isRtl, hasTouch, pointerDown, pointerMove, pointerUp, pointerEnter, pointerLeave };
